import React, { Component } from 'react';
import { Button, Modal, Form, Row, Col, DropdownButton } from 'react-bootstrap'
import Axios from 'axios';
import { connect } from 'react-redux';
class AdminSubscriptionInfo extends Component {
    state = {
    }

    render() {
        let darkmode = this.props.user.darkmode
        return (
            <Modal onHide={this.props.closeAdminSubscriptionInfo} show={this.props.show}>
                <Modal.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"}>
                    <Modal.Title>
                        Subscription Info
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={darkmode ? "darkmode-card-content" : "lightmode-card-content"}>
                    <Row>
                        Subscription Id: {this.props.adminSubscriptionInfoSelected}
                    </Row>
                </Modal.Body>
                <Modal.Footer className={darkmode ? "darkmode-card-header" : "lightmode-card-header"}>
                    <Button onClick={this.props.closeAdminSubscriptionInfo} className='button-primary' style={{ marginBottom: '10px', width: "100px" }}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        subscriptions: state.subscriptions,
        user: state.user
    }
}
function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminSubscriptionInfo);
